<div class="main-body">
    <div class="landing-page-content">
        <div class="landing-page-banner">
            <div class="content">
                <h3>SENEM</h3>
                <p [innerHTML]="labels.bannerSubTitle"></p>
            </div>
        </div>
        <div class="py-5">
            <div class="container">
                <h3 class="text-center fw-bold">{{ labels.welcome }}</h3>
                <h4 class="text-center fw-bold"> {{ labels.tagline }}</h4>
                <div class="row mt-4 align-items-center">
                    <div class="col-12 col-md-6 col-lg-5">
                        <h5 class="fw-bold  mb-2">{{ labels.customers }}</h5>
                        <ng-container *ngFor="let banner of filteredBannerDetailsList">
                            <div class="page-box" *ngIf="banner.SectionType === 'Customer'">
                                <img src="../../../../../../assets/images/check.svg" alt="Check" class="icon me-2" />
                                <p class="mb-0">
                                    {{ truncateText(banner.Details, 80) }}
                                    <span *ngIf="banner.Details.length > 80" [matTooltip]="banner.Details" [matTooltipPosition]="'right'" class="text-primary cursor-pointer custom-tooltip">...</span>
                                </p>
                            </div>
                        </ng-container>
                        <button type="button" class="btn transparent-btn" (click)="navigateToCustomers()">{{ labels.getStarted }}</button>
                    </div>
                    <div class="col-lg-2">
                        <div class="d-flex align-items-center justify-content-center">
                            <img src="assets/images/handshack.svg" width="150" class="img-fluid" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-5">
                        <h5 class="fw-bold text-end mb-2">{{ labels.agents }}</h5>
                        <ng-container *ngFor="let banner of filteredBannerDetailsList">
                            <div class="page-box agentbox" *ngIf="banner.SectionType === 'Agent'">
                                <p class="mb-0">
                                    {{ truncateText(banner.Details, 80) }}
                                    <span *ngIf="banner.Details.length > 80" [matTooltip]="banner.Details" [matTooltipPosition]="'right'" class="text-primary cursor-pointer">...</span>
                                </p>
                                <img src="../../../../../../assets/images/check.svg" alt="Check" class="icon me-2" />
                            </div>
                        </ng-container>
                        <div class="d-flex justify-content-lg-end start-btn">
                            <button type="button" class="btn primary-btn" (click)="navigateToAgents()">{{ labels.getStarted }}</button>
                        </div>

                    </div>
                </div>

            </div>
          <!--  <div class="blue-content-box">
                <div class="container">
                     <div class="row">
                        <div class="col-lg-3">
                            <img src="assets/images/profile.svg" class="img-fluid" />
                        </div>
                        <div class="col-lg-9">
                            <h5>Carla Mendoza</h5>
                            <div class="star">
                                <span class="material-icons-outlined">
                                    star
                                    </span>
                                <span class="material-icons-outlined">
                                        star
                                        </span>
                                <span class="material-icons-outlined">
                                            star
                                            </span>
                                <span class="material-icons-outlined">
                                                star
                                                </span>

                                <span class="material-symbols-outlined">
                                    star
                                    </span>
                            </div>
                            <p>“I used to have to call a lot of insurance agents to give them my information over and over again, only to learn that I did not qualify or the rate they gave me was much higher than what I was paying. This platform is much
                                better and user friendly. Wow! What a big difference.”
                            </p>
                        </div>
                    </div> 
                    
                </div>

            </div>-->
        <ngb-carousel 
  [interval]="10000" 
  [wrap]="true" 
  [pauseOnHover]="false">

  <ng-template ngbSlide *ngFor="let item of testimonials">

    <div class="blue-content-box">
      <div class="row">
        
        <!-- Image -->
        <div class="col-lg-3 custom-logo">
          <img [src]="item.image" class="img-fluid testimonial-img" />
        </div>

        <!-- Content -->
        <div class="col-lg-9 custom-content">
          <h5>{{ item.name }}</h5>

          <!-- ⭐ Dynamic Stars -->
          <div class="star">
            <ng-container *ngFor="let star of getStars(item.rating)">
              <span 
                class="material-icons-outlined"
                *ngIf="star === 'full'">star</span>

              <span 
                class="material-symbols-outlined"
                *ngIf="star === 'half'">star_half</span>

              <span 
                class="material-icons-outlined"
                *ngIf="star === 'empty'">star_outline</span>
            </ng-container>
          </div>

          <p>{{ item.message }}</p>
        </div>

      </div>
    </div>

  </ng-template>

</ngb-carousel>
        </div>
    </div>

</div>